import { Component, EventEmitter, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {DropdownConfig, DropdownOption} from "../../components/custom-dropdown/custom-dropdown.component";
import {DataPoint} from "../../components/chart/chart.component";
import {
  DealerMetric,
  DealerMetrics,
  DealerRegistration,
  DealerRegistrationResponse,
  DealerService, PayablePlate
} from "../../services/dealer-service";
import {MetricSettings} from "../../components/metric-graph-collection/metric-graph-collection.component";
import {Registration} from "../../models/registration";
import {PageEvent} from "@angular/material/paginator";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {AdminService} from "../../services/admin-service";
import {UserService} from "../../services/user-service";
import {SessionService} from "../../services/session-service";
import {PlatexListingOrder} from "../../models/platexListingOrder";

@Component({
  selector: 'pla-dealer-portal',
  templateUrl: './dealer-portal.component.html',
  styleUrls: ['./dealer-portal.component.scss']
})
export class DealerPortalComponent implements OnInit {

  // dealer info
  public isAdmin: boolean = false;
  public dealerName: string;
  public dealer: string; // 'id'
  public selectedDealerDropdownOption: DropdownOption = null;
  public dealerDropdownConfig: DropdownConfig = new DropdownConfig('Account Select', 'people_alt', [
  ], {
    showSelected: true,
    selectOnStart: true,
    emitOnStart: false,
    initialValue: new DropdownOption('*all*', 'All')
  });
  //

  // dealer metrics
  public metricLoading: boolean;
  public dateRangeTitle: string = '30 Day'
  public dateRange: string = ''
  public dealerMetrics: DealerMetric[]= [];
  public dealerStockInfo: { stockCount: number, stockValue: number};
  public dealerMetricsConfig: MetricSettings[] = [];
  public dvlaDealerMetricsConfig: MetricSettings[] = [];
  public selectedMetricRangeDropdownOption: DropdownOption = new DropdownOption('mtd', 'Month To Date');
  public metricRangeDropdownConfig: DropdownConfig = new DropdownConfig('Date Range', 'edit_calendar', [
    new DropdownOption('mtd', 'Month To Date'),
    new DropdownOption('30', 'Last 30 Days'),
    new DropdownOption('7', 'Last 7 Days')
  ], {
    showSelected: true,
    selectOnStart: true,
    emitOnStart: false,
    initialValue: new DropdownOption('mtd', 'Month To Date')
  });
  public detailModal: MatDialogRef<any> | null = null;
  public selectedRegistration: DealerRegistration;

  public payableRegistrations: PayablePlate[];
  //

  // side metrics
  public monthlySaleMetricData: DataPoint[] = [];
  //

  // stock search/sort
  public registrationResponse : DealerRegistrationResponse = new DealerRegistrationResponse();
  public stockSearching = false;
  public searchCriteria: string = '';
  public searchTrigger: EventEmitter<void> = new EventEmitter<void>();
  private debounceTimeout: number;  // Variable to store the timeout ID

  public selectedStockSortDropdownOption: DropdownOption = new DropdownOption('price_minor-DESC', 'Price High to Low');
  public stockSortDropdownConfig: DropdownConfig = new DropdownConfig('Sort By', 'swap_vert', [
    new DropdownOption('registration-ASC', 'A-Z'),
    new DropdownOption('registration-DESC', 'Z-A'),
    new DropdownOption('price_minor-ASC', 'Price Low to High'),
    new DropdownOption('price_minor-DESC', 'Price High to Low'),
    new DropdownOption('date_added-ASC', 'Most Recent'),
    new DropdownOption('date_added-DESC', 'Oldest First')
  ], {
    showSelected: true,
    selectOnStart: true,
    emitOnStart: true,
    initialValue: new DropdownOption('price_minor-DESC', 'Price High to Low')
  });
  //

  constructor(private sessionService: SessionService, private dialog: MatDialog, private dealerService: DealerService) {
    if (!this.sessionService.isLoggedIn()) return;
    this.isAdmin = this.sessionService.isAdmin();
  }

  ngOnInit(): void {
    if (this.isAdmin) {
      this.dealerService.GetDealerList((data: { site_name: string, view_name: string }[]) => {
        if (data === undefined || data === null || data.length === 0) return;
        this.dealerDropdownConfig.options = data.map((v: { site_name: string, view_name: string }) => {
          return new DropdownOption(v.site_name, v.view_name);
        });
        this.selectedDealerDropdownOption = new DropdownOption('*all*', 'All');
        this.InitFetch();
      }, (err) => {

      });
    } else {
      this.InitFetch();
    }
  }

  public InitFetch(): void {
    this.dealerService.GetDealerInfo(this.selectedDealerDropdownOption?.value || '', (data) => {
      this.dealerName = data.dealerName;
      this.dealer = data.dealer;
      this.selectedDealerDropdownOption = new DropdownOption(this.dealer, this.dealerName); // :)
      setTimeout(() => {
        this.Fetch();
      }, 100);
    }, (err) => {
      console.log(err);
    });
  }

  public Fetch(): void {
    this.GetStockMetrics();
    this.GetStockTable();
    this.GetStockInfo();
  }

  public dealerChange(e: DropdownOption): void {
    this.selectedDealerDropdownOption = e;
    this.dealerName = e.view;
    this.dealer = e.value;

    setTimeout(() => {
      this.Fetch();
    }, 100);
  }

  private GetStockInfo(): void {
    this.dealerService.GetDealerStockInfo(this.dealer, (data) => {
      this.dealerStockInfo = data;
    }, (err) => {
      console.log(err);
    });
  }

  private GetStockMetrics(): void {
    this.metricLoading = true;
    this.dealerService.GetDealerStockMetrics(this.dealer, this.selectedMetricRangeDropdownOption.value, (data) => {
      if (data.metrics.length === 0) {
        this.metricLoading = false;
        this.dealerMetrics = [];
        return;
      }
      this.dealerMetrics = data.metrics;
      data.metrics = data.metrics.sort((a: DealerMetric, b: DealerMetric) => new Date(a.date).getTime() - new Date(b.date).getTime())
      this.dateRange = `${new Date(data.metrics[0].date).toLocaleDateString()}`;
      this.dealerMetricsConfig = [
        new MetricSettings('Impressions', 'visibility', 'Impressions', 'impressions', 'impressions', [27, 155, 138], data.metrics.map((dp: DealerMetric) => {
          return {x: dp.date, y: dp.impressions};
        }), { current: 'yesterday', previous: 'previous', relativeTime: false }),
        new MetricSettings('Plate Clicks', 'ads_click', 'Plate Clicks', 'clicks', 'plate clicks', [33, 73, 83], data.metrics.map((dp: DealerMetric) => {
          return {x: dp.date, y: dp.clicks};
        }), { current: 'yesterday', previous: 'previous', relativeTime: false }),
        new MetricSettings('Dealer Clicks', 'launch', 'Impressions', 'affiliateClicks', 'dealer clicks', [250, 184, 43], data.metrics.map((dp: DealerMetric) => {
          return {x: dp.date, y: dp.affiliateClicks};
        }), { current: 'yesterday', previous: 'previous', relativeTime: false }),
        new MetricSettings('Billable Clicks', 'payments', 'Billable Clicks', 'payableClicks', 'billable clicks', [155, 27, 27], data.metrics.map((dp: DealerMetric) => {
          return {x: dp.date, y: dp.payableClicks};
        }), { current: 'yesterday', previous: 'previous', relativeTime: false }),
      ]

      this.dvlaDealerMetricsConfig = [
        new MetricSettings('DVLA Impressions', 'visibility', 'Impressions', 'dvlaImpressions', 'DVLA impressions', [27, 155, 138], data.metrics.map((dp: DealerMetric) => {
          return {x: dp.date, y: dp.dvlaImpressions};
        }), { current: 'yesterday', previous: 'previous', relativeTime: false }),
        new MetricSettings('DVLA Plate Clicks', 'ads_click', 'Plate Clicks', 'dvlaClicks', 'DVLA plate clicks', [33, 73, 83], data.metrics.map((dp: DealerMetric) => {
          return {x: dp.date, y: dp.dvlaClicks};
        }), { current: 'yesterday', previous: 'previous', relativeTime: false }),
        new MetricSettings('DVLA Dealer Clicks', 'launch', 'Impressions', 'dvlaAffiliateClicks', 'DVLA dealer clicks', [250, 184, 43], data.metrics.map((dp: DealerMetric) => {
          return {x: dp.date, y: dp.dvlaAffiliateClicks};
        }), { current: 'yesterday', previous: 'previous', relativeTime: false }),
        new MetricSettings('DVLA Billable Clicks', 'payments', 'Billable Clicks', 'dvlaPayableClicks', 'DVLA billable clicks', [155, 27, 27], data.metrics.map((dp: DealerMetric) => {
          return {x: dp.date, y: dp.dvlaPayableClicks};
        }), { current: 'yesterday', previous: 'previous', relativeTime: false })
      ]

      this.payableRegistrations = data.metrics.map((dp: DealerMetric) => {
        return dp.payablePlates.map((p: PayablePlate) => {
          p = Object.assign(new PayablePlate(), p) as PayablePlate;
          return p.addDate(dp.date);
        });
      }).flat();

      this.metricLoading = false;
    }, (err) => {
      console.log(err);
      this.metricLoading = false;
    });
  }

  public ClickManageDVLA(): void {
    alert('Manage DVLA -> tbc');
  }

  public ClickManageDealerPlate(templateRef: TemplateRef<any>, registration: DealerRegistration): void {
    this.selectedRegistration = registration;
    this.detailModal = this.dialog.open(templateRef, {
      maxWidth: '500px',
    });
    this.detailModal.afterClosed().subscribe(() => {
      this.selectedRegistration = null;
      this.GetStockTable(this.registrationResponse.pagination.page);
    });
  }

  public SelectedRegPriceChange(event: string) {
    if (this.selectedRegistration) {
      const newPrice = Number.parseFloat(event) * 100;
      if (isNaN(newPrice)) {
        return; // dont set
      }
      this.selectedRegistration.price_minor = newPrice;
    }
  }

  public SelectedRegPriceValidator(event: string): boolean {
    //
    return true;
  }

  // metric sort
  public metricRangeSortChange(e: DropdownOption): void {
    if (this.selectedMetricRangeDropdownOption.value === e.value) return;
    this.selectedMetricRangeDropdownOption = e;
    if (e.value === 'mtd') {
      this.dateRangeTitle = 'Month To Date';
    } else if (e.value === '7') {
      this.dateRangeTitle = '7 Day';
    } else {
      this.dateRangeTitle = '30 Day';
    }
    this.GetStockMetrics();
  }
  //

  // search / sort
  private GetStockTable(page: number = 1): void {
    if (this.selectedStockSortDropdownOption === undefined || this.selectedStockSortDropdownOption === null) return;
    this.stockSearching = true;
    const selected = this.selectedStockSortDropdownOption.value.split('-');
    const order = selected[0];
    const direction = selected[1];

    this.dealerService.GetDealerStockTable(this.dealer, this.searchCriteria || '', order, direction, page.toString(), (data: DealerRegistrationResponse) => {
      this.registrationResponse = data;
      this.stockSearching = false;
    }, (err) => {
      console.log(err);
      this.stockSearching = false;
    });
  }

  public filterSearchResults(input: string): void {
    this.searchCriteria = input;

    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = window.setTimeout(() => {
      this.GetStockTable();
    }, 500);
  }

  public stockSortChange(e: DropdownOption): void {
    if (e === undefined || e === null) return;
    this.selectedStockSortDropdownOption = e;
    this.GetStockTable();
  }

  public paginate(event: PageEvent): void {
    this.GetStockTable(event.pageIndex + 1);
  }
  //


}
